<template>
  <div class="container">
    <Header :active="2"></Header>
    <Partner class="anli-partner" :showDot="true" :title="'电影/电视/动画云渲染'"></Partner>
    <ItemList></ItemList>
    <Position></Position>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '../components/Header/index'
import Partner from '../components/Section/section5'
import ItemList from '../components/anli/index'
import Position from '../components/Position/index'
import Footer from '../components/Footer/index'
export default {
  components: {
    Header,
    Partner,
    ItemList,
    Position,
    Footer
  },
  data() {
    return {
      
    }
  },
}
</script>